import { analyseAnfrage } from "../../../utils/apiTypes";

export interface korrelation {
    korrelationList: Array<Array<korrelationResult>>;
    headerList: Array<string>;
    loadingKorrelation: boolean;
}

export interface korrelationFilter {
    calculatedKorrelationenList: Array<analyseAnfrage>;
    loadingCalculatedKorrelationen: boolean;
    selectedCalculatedKorrelation: analyseAnfrage;

    korrelationZwischen: CorrelationCalculationType;
    korrelationZwischenTemp: CorrelationCalculationType;
    korrelationZwischenVorher: CorrelationCalculationType;
    korrelationZwischenWert: zwischenWertObject;
    korrelationZwischenWertTemp: zwischenWertObject;
    korrelationZwischenWertVorher: zwischenWertObject;

    slider: number[];
    sliderTemp: number[];
    sliderVorher: number[];

    ergebnistyp: CorrelationResultType;

    openGroups: string[],
    
    isListeLoading: boolean;
    isChanged:boolean;
    isInitFirstLoad: boolean;
}

export interface korrelationResult {
    row: string;
    col: string;
    value:number;
}

export interface marksObject {
    value: number,
    label: string
}

export interface zwischenWertObject {
    value: string,
    groupBy: string,
    id: string
}

export enum CorrelationCalculationType {
    none = "non",
    betweenMessstellen = "betweenMessstellen",
    betweenKenngroessen = "betweenKenngroessen",
    all = "all"
}

export enum CorrelationResultType {
    single = "single",
    count = "count",
    percentage = "percentage"
}